import { render, staticRenderFns } from "./DataListInscritsView.vue?vue&type=template&id=6d73426a&"
import script from "./DataListInscritsView.vue?vue&type=script&lang=js&"
export * from "./DataListInscritsView.vue?vue&type=script&lang=js&"
import style0 from "./DataListInscritsView.vue?vue&type=style&index=0&id=6d73426a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports